export default __webpack_public_path__ + "static/media/aboutApp.1a2d94d7.jpg";